// Fase 3 · Políticas de red del cliente HTTP (puras, testeables).

export const DEFAULT_GET_TIMEOUT_MS = 20000;
export const DEFAULT_MUTATION_TIMEOUT_MS = 15000;

// Llamadas legítimamente largas: exportaciones/descargas, informes, escaneo
// de carta, importaciones, subidas. Sin timeout por defecto (como antes).
const LONG_RUNNING_URL = /(export|download|report|informe|pdf|excel|xlsx|csv|scan|claude|readcarta|import|upload|backup|bootstrap)/i;

const isFormData = (data) =>
  typeof FormData !== "undefined" && data instanceof FormData;

/**
 * Timeout por defecto para una request si el caller no fijó uno.
 * Devuelve `undefined` cuando no se debe imponer ninguno.
 */
export function defaultTimeoutFor(config) {
  if (!config) return undefined;
  if (config.timeout != null && config.timeout !== 0) return undefined; // respetar el del caller
  if (config.noDefaultTimeout) return undefined;
  const rt = config.responseType;
  if (rt === "blob" || rt === "arraybuffer" || rt === "stream") return undefined;
  if (isFormData(config.data)) return undefined;
  if (LONG_RUNNING_URL.test(config.url || "")) return undefined;
  const method = (config.method || "get").toLowerCase();
  return method === "get" || method === "head" || method === "options"
    ? DEFAULT_GET_TIMEOUT_MS
    : DEFAULT_MUTATION_TIMEOUT_MS;
}

/**
 * Agrupa muestras de latencia y las entrega en lote como mucho cada
 * `intervalMs` (un único dispatch en vez de uno por respuesta, que
 * re-ejecutaba todos los selectores montados en cada request).
 */
export function createLatencySampler(flush, { intervalMs = 2000, now = () => Date.now(), schedule = setTimeout } = {}) {
  let buffer = [];
  let timer = null;
  let lastFlushAt = 0;

  const doFlush = () => {
    timer = null;
    if (buffer.length === 0) return;
    const batch = buffer;
    buffer = [];
    lastFlushAt = now();
    try {
      flush(batch);
    } catch {
      /* la telemetría nunca rompe nada */
    }
  };

  return {
    add(ms) {
      const v = Number(ms);
      if (!Number.isFinite(v) || v < 0) return;
      buffer.push(v);
      if (timer) return;
      const wait = Math.max(0, intervalMs - (now() - lastFlushAt));
      timer = schedule(doFlush, wait);
    },
    flushNow: doFlush,
    size: () => buffer.length,
  };
}

/**
 * Clon profundo para el monitor, con tope de tamaño: una respuesta enorme
 * (bootstrap, catálogo) no se clona entera en cada request.
 */
export function cloneForMonitor(value, maxChars = 50000) {
  if (value === undefined) return value;
  let text;
  try {
    text = typeof value === "string" ? value : JSON.stringify(value);
  } catch {
    return "[no serializable]";
  }
  if (text === undefined) return value;
  if (text.length > maxChars) {
    return { _truncated: true, size: text.length, preview: text.slice(0, 2000) };
  }
  // Los strings (cuerpos ya serializados) se devuelven tal cual, como antes.
  if (typeof value === "string") return value;
  try {
    return JSON.parse(text);
  } catch {
    return value;
  }
}
